// page-view-day-healt
(function (Drupal) {
  Drupal.behaviors.alDiaConTuSalud = {
    attach: function (context, settings) {
      if (document.body.classList.contains('page-view-day-healt')) {
        const card = context.querySelector('#block-visionia-keralty-contenidoprincipaldelapagina > .content > .views-element-container > .view-day-healt  > .view-content > .views-row:first-of-type .card-article-main');

        if (!card) {
          return;
        }

        const img = card.querySelector('#block-visionia-keralty-contenidoprincipaldelapagina > .content > .views-element-container > .view-day-healt  > .view-content > .views-row:first-of-type .card-article-main img');
        const cardText = card.querySelector('#block-visionia-keralty-contenidoprincipaldelapagina > .content > .views-element-container > .view-day-healt  > .view-content > .views-row:first-of-type .card-article-main .card-text');
        const originalPosition = img.parentNode;

        // Función para mover la imagen
        function handleResize() {
          if (window.innerWidth <= 992) {
            if (!cardText.contains(img)) {
              cardText.insertBefore(img, cardText.firstChild);
            }
          } else {
            if (cardText.contains(img)) {
              originalPosition.insertBefore(img, originalPosition.firstChild);
            }
          }
        }

        // Detectar el cambio de tamaño
        window.addEventListener('resize', handleResize);

        // Ejecutar al cargar la página
        handleResize();
      }
    }
  };
})(Drupal);
